<template>
  <v-row align="center" justify="end">
    <v-col
      order="2"
      order-sm="1"
      class="py-0"
      style="flex-grow:1; flex-shrink: 0;"
    >
      <InventoryTemplateSelector
        :value="value"
        @input="v => $emit('input', v)"
        :icon="icon"
        :loading="loading"
      ></InventoryTemplateSelector>
    </v-col>
    <v-col
      v-if="getIsAdmin"
      order="1"
      order-sm="2"
      class="py-0"
      :class="{ 'mb-2': $vuetify.breakpoint.xsOnly }"
      style="flex-grow:0; flex-shrink: 1;"
    >
      <v-toolbar dense elevation="2">
        <v-tooltip bottom v-if="edit === true && value && value !== null">
          <template v-slot:activator="{ on }">
            <v-btn
              :large="!$vuetify.breakpoint.xsOnly"
              v-on="on"
              icon
              text
              @click="setDefault"
            >
              <v-icon v-if="getIsDefaultTemplate">fa-star</v-icon>
              <v-icon v-else>far fa-star</v-icon>
            </v-btn>
          </template>
          <span>Configurer comme gabarit par défaut</span>
        </v-tooltip>
        <v-tooltip bottom v-if="edit === true && value && value !== null">
          <template v-slot:activator="{ on }">
            <v-btn
              :large="!$vuetify.breakpoint.xsOnly"
              v-on="on"
              icon
              text
              @click="saveTemplate"
            >
              <v-icon>fa-save</v-icon>
            </v-btn>
          </template>
          <span>Enregistrer le gabarit</span>
        </v-tooltip>
        <v-tooltip bottom v-if="edit === true">
          <template v-slot:activator="{ on }">
            <v-btn
              :large="!$vuetify.breakpoint.xsOnly"
              v-on="on"
              icon
              text
              @click="saveAsNewTemplate"
            >
              <v-icon>fa-copy</v-icon>
            </v-btn>
          </template>
          <span>Enregistrer comme nouveau gabarit</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-checkbox
              class="no-margin"
              hide-details
              v-model="editModel"
              v-on="on"
              on-icon="fa-pen-square"
              off-icon="fa-pen-square"
            ></v-checkbox>
          </template>
          <span>Mode d'édition des gabarits</span>
        </v-tooltip>
      </v-toolbar>
    </v-col>
  </v-row>
</template>

<script>
import InventoryTemplateSelector from "./InventoryTemplateSelector";
import { mapGetters } from "vuex";
import { api } from "@/api";
export default {
  name: "InventoryTemplateEditor",
  components: {
    InventoryTemplateSelector
  },
  props: {
    value: {
      required: true
    },
    template: {
      required: true
    },
    icon: {
      type: Boolean,
      default: true
    },
    edit: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getIsAdmin", "getInventoryTemplates", "getStoreId"]),
    getIsDefaultTemplate() {
      const t = this.getInventoryTemplates.find(x => x.id === this.value);
      if (t !== undefined && t.is_default === true) {
        return true;
      } else {
        return false;
      }
    },
    editModel: {
      get() {
        return this.edit;
      },
      set(v) {
        this.$emit("update:edit", v);
      }
    }
  },
  methods: {
    async setDefault() {
      try {
        this.$store.dispatch("startLoadingOverlay");
        if (this.value && this.value !== null) {
          await api.setDefaultInventoryTemplate(this.value);
          this.$store.dispatch("loadInventoryTemplates", {
            store: this.getStoreId
          });
        }
      } finally {
        this.$store.dispatch("endLoadingOverlay");
      }
    },
    async saveTemplate() {
      try {
        this.$store.dispatch("startLoadingOverlay");

        if (this.value && this.value !== null) {
          const template = this.getInventoryTemplates.find(
            x => x.id === this.value
          );
          const data = {
            ...template,
            templates: this.template
          };
          this.$emit("saveTemplate");
          await api.putInventoryTemplate(this.value, data);
          this.$store.dispatch("loadInventoryTemplates", {
            store: this.getStoreId
          });
        }
      } finally {
        this.$store.dispatch("endLoadingOverlay");
      }
    },
    async saveAsNewTemplate() {
      try {
        let res = await this.$dialog.prompt({
          text: "Nom du nouveau gabarit",
          title: "Nouveau gabarit"
        });
        if (res) {
          this.$store.dispatch("startLoadingOverlay");
          const data = {
            name: res,
            store: this.getStoreId,
            templates: this.template,
            is_default: false
          };
          this.$emit("saveTemplate");
          const apiRes = await api.postInventoryTemplate(data);
          await this.$store.dispatch("loadInventoryTemplates", {
            store: this.getStoreId
          });
          this.templateId = apiRes.id;
        }
      } finally {
        this.$store.dispatch("endLoadingOverlay");
      }
    }
  }
};
</script>

<style></style>
